module.exports = __webpack_public_path__ + "img/helloquence.34aa4449.jpg";